import React from 'react';
import { useQuery } from '@apollo/client';
import { Card, Loading } from '@avila-tek/ui/src';
import { GET_SETTINGS } from '../graphql/queries';
import { Settings } from '../models';
import Layout from '../components/layout/Layout';

function FrequentlyAskedQuestionPage() {
  const { data, loading, error } = useQuery<{
    settings: Settings[];
  }>(GET_SETTINGS, {
    variables: {
      limit: 1,
    },
    fetchPolicy: 'network-only',
  });

  if (loading) {
    return <Loading />;
  }

  const settings = data?.settings.length > 0 ? data?.settings[0] : null;

  return (
    <Layout>
      <main className="w-full flex items-center bg-neutral-100 ">
        <Card className="max-w-[800px] mx-auto p-5 px-10 shadow-sm space-y-3 h-auto overflow-y-auto mt-10">
          <h3 className="text-color-primary-text-300 text-xl font-semibold uppercase mt-50">
            Preguntas frecuentes
          </h3>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: settings?.frequentlyAskedQuestions,
            }}
          />
        </Card>
      </main>
    </Layout>
  );
}

export default FrequentlyAskedQuestionPage;
